<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <button class="close btn btn-icon" @click="$emit('close')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
            </button>
            <h6>{{ title }}</h6>
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',

    props: ['title']
  }
</script>

<style lang="scss" scoped>
  .modal-mask {
    @apply fixed pin-t pin-l w-full h-full;
    z-index: 9998;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    @apply absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-container {
    @apply relative mx-auto bg-white;
    width: 600px;
    overflow: hidden;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;

    .modal-header {
      @apply relative bg-lerner-blue py-3 mb-6 px-3;

      .close {
        @apply absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        height: 25px;

        svg {
          @apply fill-current h-6 w-6 text-white;
        }
      }

      h6 {
        @apply leading-none mb-0 text-white pl-3;
      }
    }

    .modal-body {
      @apply p-3;
    }
  }

  .modal-enter {
    @apply opacity-0;
  }

  .modal-leave-active {
    @apply opacity-0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    transform: scale(1.1);
  }
</style>
